import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown',
  standalone: false
})
export class MarkdownPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';
    return this.sanitizer.bypassSecurityTrustHtml(this.parse(value));
  }

  private parse(text: string): string {
    const lines = text.split('\n');
    const output: string[] = [];
    let inList = false;

    for (const line of lines) {
      // Horizontal rule
      if (/^-{3,}$/.test(line.trim())) {
        if (inList) { output.push('</ul>'); inList = false; }
        output.push('<hr class="md-hr">');
        continue;
      }

      // Headings (### and ##)
      const h3 = line.match(/^###\s+(.+)$/);
      if (h3) {
        if (inList) { output.push('</ul>'); inList = false; }
        output.push(`<p class="md-h3">${this.inline(h3[1])}</p>`);
        continue;
      }
      const h2 = line.match(/^##\s+(.+)$/);
      if (h2) {
        if (inList) { output.push('</ul>'); inList = false; }
        output.push(`<p class="md-h2">${this.inline(h2[1])}</p>`);
        continue;
      }

      // List item
      const li = line.match(/^[-*]\s+(.+)$/);
      if (li) {
        if (!inList) { output.push('<ul class="md-ul">'); inList = true; }
        output.push(`<li>${this.inline(li[1])}</li>`);
        continue;
      }

      // Close open list on non-list line
      if (inList) { output.push('</ul>'); inList = false; }

      // Empty line — skip (avoids excessive spacing)
      if (!line.trim()) continue;

      output.push(`<p class="md-p">${this.inline(line)}</p>`);
    }

    if (inList) output.push('</ul>');
    return output.join('');
  }

  private inline(text: string): string {
    // Bold before italic to avoid conflict
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
    return text;
  }
}
